export default {
  FONT_FAMILY: 'Source Sans Pro',
  BGIMAGE_MODE: 'none',
  BGIMAGE_POSITION: 'center-center',
  BACKGROUND_SIZE: 'auto',
  COLOR: { index: -1, color: 'none' },
};
